import { IrshStepValues } from '../IrshPages.types';

import { buildIrshSearchParams } from './buildIrshSearchParams';

export const appendIrshSearchParams = ({
  path,
  values,
}: {
  path: string;
  values?: Partial<IrshStepValues>;
}): string => {
  return `${path}${buildIrshSearchParams({
    issueUniqueName: values?.issue?.uniqueName,
    reasonName: values?.reasonNameFromUrl,
  })}`;
};
